import { useTemplateEngine } from './templateEngine/useTemplateEngine';
import { useIsMultiDraft } from './useIsMultiDraft';

export const useProjectSettings = () => {
  const { isTemplateEngineEnabled } = useTemplateEngine();
  const isMultiDraftEnabled = useIsMultiDraft();

  return {
    isMultiDraftEnabled,
    isTemplateEngineEnabled,
  };
};
